import { getParsedClientCookie } from '../../cookiesUtils';
import { ExperimentClient, ExperimentAnalyticsEvent, ExperimentClientData, ScreenResolution } from '../types';
import { EXPERIMENT_COOKIE, EXPERIMENT_HEADER } from '../const';

export function retrieval() {
  function byExperiment(
    experiments: ExperimentClient | null,
    experimentId: string,
  ): ExperimentClientData | undefined {
    return experiments?.experiments.find((experiment) => experiment.experiment === experimentId);
  }

  function fromCookie(pathEnsured?: string): ExperimentClient | null {
    const cookieExperiments = getParsedClientCookie<ExperimentClient>(EXPERIMENT_COOKIE);

    if (!cookieExperiments) {
      return null;
    }

    if (pathEnsured && cookieExperiments.path !== pathEnsured) {
      return null;
    }

    return {
      experiments: cookieExperiments.experiments,
      metadata: cookieExperiments.metadata,
    };
  }

  function fromHeader(header: Headers): ExperimentClient | null {
    const experimentsFromHeader = header.get(EXPERIMENT_HEADER);
    if (!experimentsFromHeader) {
      return null;
    }

    const experimentHeader = JSON.parse(experimentsFromHeader) as ExperimentClient;

    return {
      experiments: experimentHeader.experiments,
      metadata: experimentHeader.metadata,
    };
  }

  return {
    byExperiment,
    fromCookie,
    fromHeader,
  };
}

export function eventList(
  experiments: ExperimentClientData[],
  analyticsEnabled: boolean,
): ExperimentAnalyticsEvent[] {
  if (!analyticsEnabled || experiments.length === 0) {
    return [];
  }

  return experiments
    .filter((experiment) => experiment.variation)
    .map((experiment) => {
      const event = {
        type: 'Server side experiment',
        experience: experiment.experiment,
        variationName: experiment.variation,
      };

      return event;
    });
}

export function getScreenResolutionString(screenResolution: ScreenResolution): string {
  return `${screenResolution.width}x${screenResolution.height}`;
}
